import {
  colors as brandColors,
  typography as brandTypography,
  radius as brandRadius,
} from '@exekuity/design-tokens/brands/dominoris';

// Scope D (2026-04-14): colors now come from the dominoris brand pkg directly
// (brass/silver/void observatory palette). Typography families remain overridden
// because the brand scale is optimized for landing page hero sizes and the
// brand heading font is Playfair Display (serif) which is unsuitable for
// a dense clinical dashboard — families stay Space Grotesk + Manrope.
export const colors = brandColors;

export const typography = {
  families: {
    heading: '"Space Grotesk", "Manrope", sans-serif',
    body: '"Manrope", "Segoe UI", sans-serif',
    mono: '"JetBrains Mono", monospace',
  },
  weights: brandTypography.weight,
} as const;

export const radius = brandRadius;
